// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__eDllg","button":"Menu_button__z3ins","nav":"Menu_nav__EttjZ","fade":"Menu_fade__EUPu3","menu-list":"Menu_menu-list__9oPMD","link":"Menu_link__eEbuD"};